// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"video-module--wrapper--25zGR","video":"video-module--video--aDW3c","inner":"video-module--inner--yFp47","content":"video-module--content--2rX7s"};